'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FlatButton = require('material-ui/FlatButton');

var _FlatButton2 = _interopRequireDefault(_FlatButton);

var _Dialog = require('material-ui/Dialog');

var _Dialog2 = _interopRequireDefault(_Dialog);

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

var _VideoFormDialog = require('./VideoFormDialog');

var _VideoFormDialog2 = _interopRequireDefault(_VideoFormDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddVideoDialog = function (_React$Component) {
    _inherits(AddVideoDialog, _React$Component);

    function AddVideoDialog() {
        _classCallCheck(this, AddVideoDialog);

        return _possibleConstructorReturn(this, (AddVideoDialog.__proto__ || Object.getPrototypeOf(AddVideoDialog)).apply(this, arguments));
    }

    _createClass(AddVideoDialog, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                open = _props.open,
                title = _props.title,
                onCancel = _props.onCancel,
                onSubmit = _props.onSubmit;


            return _react2.default.createElement(_VideoFormDialog2.default, {
                title: 'Adicionar V\xEDdeo',
                open: open,
                onCancel: onCancel,
                onSubmit: onSubmit,
                modal: true
            });
        }
    }]);

    return AddVideoDialog;
}(_react2.default.Component);

exports.default = AddVideoDialog;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9xdWVzdGlvbnMvQWRkVmlkZW9EaWFsb2cuanMiXSwibmFtZXMiOlsiQWRkVmlkZW9EaWFsb2ciLCJwcm9wcyIsIm9wZW4iLCJ0aXRsZSIsIm9uQ2FuY2VsIiwib25TdWJtaXQiLCJSZWFjdCIsIkNvbXBvbmVudCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7Ozs7Ozs7SUFFcUJBLGM7Ozs7Ozs7Ozs7O2lDQUNSO0FBQUEseUJBRXVDLEtBQUtDLEtBRjVDO0FBQUEsZ0JBRUdDLElBRkgsVUFFR0EsSUFGSDtBQUFBLGdCQUVTQyxLQUZULFVBRVNBLEtBRlQ7QUFBQSxnQkFFZ0JDLFFBRmhCLFVBRWdCQSxRQUZoQjtBQUFBLGdCQUUwQkMsUUFGMUIsVUFFMEJBLFFBRjFCOzs7QUFJTCxtQkFDSSw4QkFBQyx5QkFBRDtBQUNJLHVCQUFNLG9CQURWO0FBRUksc0JBQU1ILElBRlY7QUFHSSwwQkFBVUUsUUFIZDtBQUlJLDBCQUFVQyxRQUpkO0FBS0k7QUFMSixjQURKO0FBU0g7Ozs7RUFkdUNDLGdCQUFNQyxTOztrQkFBN0JQLGMiLCJmaWxlIjoiQWRkVmlkZW9EaWFsb2cuanMiLCJzb3VyY2VSb290IjoiL3NyYyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgRmxhdEJ1dHRvbiBmcm9tICdtYXRlcmlhbC11aS9GbGF0QnV0dG9uJztcbmltcG9ydCBEaWFsb2cgZnJvbSAnbWF0ZXJpYWwtdWkvRGlhbG9nJztcbmltcG9ydCBUZXh0RmllbGQgZnJvbSAnbWF0ZXJpYWwtdWkvVGV4dEZpZWxkJztcbmltcG9ydCBWaWRlb0Zvcm1EaWFsb2cgZnJvbSAnLi9WaWRlb0Zvcm1EaWFsb2cnO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBBZGRWaWRlb0RpYWxvZyBleHRlbmRzIFJlYWN0LkNvbXBvbmVudCB7XG4gICAgcmVuZGVyKCkge1xuXG4gICAgICAgIGNvbnN0IHsgb3BlbiwgdGl0bGUsIG9uQ2FuY2VsLCBvblN1Ym1pdCB9ID0gdGhpcy5wcm9wcztcblxuICAgICAgICByZXR1cm4gKFxuICAgICAgICAgICAgPFZpZGVvRm9ybURpYWxvZ1xuICAgICAgICAgICAgICAgIHRpdGxlPVwiQWRpY2lvbmFyIFbDrWRlb1wiXG4gICAgICAgICAgICAgICAgb3Blbj17b3Blbn1cbiAgICAgICAgICAgICAgICBvbkNhbmNlbD17b25DYW5jZWx9XG4gICAgICAgICAgICAgICAgb25TdWJtaXQ9e29uU3VibWl0fVxuICAgICAgICAgICAgICAgIG1vZGFsXG4gICAgICAgICAgICAvPlxuICAgICAgICApO1xuICAgIH1cbn0iXX0=


//////////////////
// WEBPACK FOOTER
// ./src/client/components/questions/AddVideoDialog.js
// module id = 2551
// module chunks = 0